import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { UpdateAttribute } from '@models/updateAttribute.model';
import { StorageService } from './storage.service';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class AttributeNewDeviceService extends HttpService {
  private apiUrl = `${environment.apiUrl}/devices`;

  updateAttributes(attributes: UpdateAttribute[]): Observable<any> {
    const options = this.createOptions();
    return this.post(`${this.apiUrl}/sensors/attributes/sync`, attributes, options);
  }

  private createOptions() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.storageService.get('tok')}`
      })
    };
  }
}
